import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Alert, ProgressBar } from "react-bootstrap";
import {
  GetUserData,
  GetUserPerks,
  // GetUserCoins,
  // GetUserSkills,
  // GetSkillImage,
} from "../Database/Functions";
import Icon from "../../components/UI/Icon/Icon";
import IconList from "../../components/UI/IconList/IconList";
import Card from "../../components/UI/Card/Card";
import Avatar from "../../components/UI/Avatar/Avatar";
import { Link } from "react-router-dom";

import "./UserPanel.scss";

import userImageDefault from "../../img/default_user.png";
import Section from "../UI/Section/Section";
import Header from "../UI/Header/Header";

import SmileyBg from "../../img/smiley-id-bg.svg";
import LineBg from "../../img/line-bg.svg";
import Table from "../UI/Table/Table";

const debug = false;

export default function UserPanelWide(props) {
  const [error, setError] = useState("");
  const [perks, setLoadedPerks] = useState();
  // const [coins, setLoadedCoins] = useState();
  const [userData, setUserData] = useState({
    name: "______",
    about: "______",
    speciality: "______",
    about: "______",
    projectInfo: "______",
    photoURL: userImageDefault,
  });
  const [userEmail, setUserEmail] = useState();
  // const [userSubText, setUserSubText] = useState();

  const [isLoading, setIsLoadingState] = useState();
  const { currentUser, contracts, rerfreshContracts} = useAuth();
  const userID = props.userID ? props.userID : currentUser.uid;

  const tasks = {
    currentMy: contracts.filter((contract) => (contract.party == userID && contract.status < 2)).length,
    totalMy: contracts.filter((contract) => (contract.party == userID && contract.status == 2)).length,
    current: contracts.filter((contract) => (contract.status < 2)).length,
    total: contracts.filter((contract) => (contract.status == 2)).length,
  }
  const tasks_title = props.userID ? "Задачи" : "Мои задачи";

  debug && console.log("UserPanelWide.js: User data:", userData);

  //Load Perks
  useEffect(() => {
    rerfreshContracts();
    setIsLoadingState(true);
    // TODO сделать авторизацию при запросах к бд
    GetUserPerks(userID).then((items) => {
      // setIsLoadingState(false);
      setLoadedPerks(items);
      // console.log(perks);
    });

    GetUserData(userID).then((data) => {
      setUserData(data);
    });

    // TODO сделать авторизацию при запросах к бд
    // GetUserCoins(userID).then((items) => {
    //   // setIsLoadingState(false);
    //   setLoadedCoins(items);
    // });

    setIsLoadingState(false);
    //set email
    setUserEmail(props.userID ? "***" : currentUser.email);
  }, []);


  return (
    currentUser && (
      <>
        {error && <Alert variant="danger">{error}</Alert>}
        <Section>
          <Card size="big">
            <Avatar
              image={(userData && "photoURL" in userData && userData.photoURL) || userImageDefault}
              size="big"
              className="Card__image"
              isOnline={false}
            />
            <div className="Card__section">
              <div className="Card__score">{"xx"} очков</div>
            </div>
            <div className="Card__section">
              <div className="Card__title">{userData && userData.name}</div>
            </div>
            <div className="Card__section">
              <div className="Card__body">{userData && userData.about}</div>
            </div>
            {!props.userID && (
              <Link className="Card__edit-btn" to="/profile/update-profile">
                <Icon className="Card__icon" image="edit" size="m" />
              </Link>
            )}
          </Card>
        </Section>
        <Section>
          {isLoading && <i>загрузка...</i>}
          <IconList layout="horizontal" >
          {perks && 
          perks.map((perk, i, a) => (
            <Icon className="Icon-list__item" image={perk.icon} size="m2" style={{marginBottom:17}} key={i}/>
          ))}
          </IconList>
          <Link to="/profile/info" style={{color:"inherit", fontSize: "15px", display: "inline-block"}}>Подробнее о достижениях</Link>
        </Section>
        <Section>
          <Header>Персональная информация</Header>
          <IconList layout="vertical">
            <Icon className="Icon-list__item" image="degree" title={userData && userData.speciality ? userData.speciality : ("Не указано")} size="m"/>
            <Icon className="Icon-list__item" image="email" title={userEmail} size="m" />
            <Icon className="Icon-list__item" image="cake" title={"Не указано"} size="m" />
          </IconList>
          <div style={{textAlign: "right"}}>
            <img src={SmileyBg} style={{marginBottom: 14, marginLeft: 0, marginRight: 0}}/>
          </div>
        </Section>
        <Section>
          <Header>Прогресс</Header>
          <div style={{position: "absolute", top: -19, left:-30, right:-30}}>
            <img src={LineBg} style={{objectFit: "cover", width: "100%"}}/>
          </div>
          <Table data={[
            ["",          "Сейчас",     "Всего"       ],
            [tasks_title, tasks.currentMy, tasks.totalMy ],
            ["Всего",     "-",             tasks.total  ],
          ]}/>
        </Section>
      </>
    )
  );
}
